import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { ConnectionService } from 'ng-connection-service';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TechnicalWorkComponent } from '../../../containers/technical-work/technical-work.component';

@Injectable({
  providedIn: 'root',
})
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private _dialog: MatDialog,
    private connectionService: ConnectionService,
    private _toastr: ToastrService
  ) {}

  private corsErrorRedirected = false;

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error('Error Event');
          } else if (error.status === 0 && !this.corsErrorRedirected) {
            this.corsErrorRedirected = true;
            this.connectionService.monitor().subscribe(isConnected => {
              if (isConnected.hasNetworkConnection === true) {
                this._dialog.open(FormDialogComponent, {
                  width: '100%',
                  height: '100%',
                  disableClose: true,
                  data: {
                    panelClass: 'technical-work-modal',
                    content: TechnicalWorkComponent,
                  },
                });
              } else {
                this._toastr.error(`Проверьте поключение к интернету`, '', {
                  timeOut: 4000,
                });
              }
            });
          }
        }
        return throwError(error);
      })
    );
  }
}
